<template>
  <div v-if="isShow" class="video-mask" @touchstart="closeClick">
    <iframe
      v-if="url && url.includes('youku')"
      style="width: 100%; height: 64.2593rem"
      :src="url"
    ></iframe>
    <video
      v-else
      @touchstart.stop
      :src="url"
      width="100%"
      height="auto"
      controls
      autoplay
    ></video>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isShow = ref(false);
const url = ref("");
const show = (_url) => {
  url.value = _url;
  isShow.value = true;
};
const closeClick = () => {
  isShow.value = false;
};
defineExpose({
  show,
});
</script>

<style lang="scss" scoped>
.video-mask {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  animation-duration: 250ms;
  transition-duration: 250ms;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>